
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundRateGrid extends Serenity.EntityGrid<PsVatRefundRateRow, any> {
        protected getColumnsKey() { return PsVatRefundRateColumns.columnsKey; }
        protected getDialogType() { return PsVatRefundRateDialog; }
        protected getIdProperty() { return PsVatRefundRateRow.idProperty; }
        protected getInsertPermission() { return PsVatRefundRateRow.insertPermission; }
        protected getLocalTextPrefix() { return PsVatRefundRateRow.localTextPrefix; }
        protected getService() { return PsVatRefundRateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

             buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'refresh-button'), 1)
            //  buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
           

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: PsVatRefundRateService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons
        }
    }
}